import * as React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../api.js";
import { t } from "../i18n.js";
import { LocaleSwitcher } from "../components.js";

/** Passwordless host login: request a magic-link email. */
export function Login(): React.ReactElement {
  const [params] = useSearchParams();
  const [email, setEmail] = React.useState("");
  const [sent, setSent] = React.useState(false);
  const [busy, setBusy] = React.useState(false);
  const erro = params.get("erro"); // link | expirado | conta (from verify redirect)

  const submit = async (): Promise<void> => {
    const addr = email.trim();
    if (!addr || !addr.includes("@")) return;
    setBusy(true);
    await api.magicRequest(addr);
    setBusy(false);
    setSent(true);
  };

  return (
    <div className="mx-auto flex min-h-full max-w-md flex-col gap-6 p-6">
      <header className="flex items-center justify-between">
        <Link to="/" className="font-display text-display-sm">Klapzo</Link>
        <LocaleSwitcher />
      </header>

      <main className="flex flex-col gap-5 rounded-md border border-border p-6">
        <h1 className="font-display text-display-md">{t("login.title")}</h1>

        {erro && (
          <p className="bg-warning rounded-md p-3 text-primary-foreground">
            {t(`login.err.${erro}`)}
          </p>
        )}

        {sent ? (
          <>
            <h2 className="font-display text-display-sm">{t("login.sent")}</h2>
            <p className="leading-normal text-muted">{t("login.sentDesc")}</p>
            <button onClick={() => setSent(false)} className="self-start rounded-md border border-border px-4 py-2">
              {t("login.again")}
            </button>
          </>
        ) : (
          <>
            <p className="leading-normal text-muted">{t("login.subtitle")}</p>
            <label className="flex flex-col gap-2">
              <span className="text-sm">{t("login.email")}</span>
              <input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && void submit()}
                type="email"
                autoComplete="email"
                autoFocus
                className="rounded-md border border-border p-3 text-lg"
              />
            </label>
            <button
              onClick={() => void submit()}
              disabled={busy}
              className="rounded-md bg-primary p-3 font-bold text-primary-foreground disabled:opacity-50"
            >
              {t("login.cta")}
            </button>
          </>
        )}

        <Link to="/" className="text-accent text-sm">{t("login.home")}</Link>
      </main>
    </div>
  );
}
